var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuditcomp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint0_linear_356_10111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 150H30V53C34.242 52.9952 38.3089 51.308 41.3084 48.3085C44.308 45.3089 45.9952 41.242 46 37H104C103.996 39.1014 104.408 41.1828 105.213 43.1238C106.018 45.0648 107.2 46.8268 108.691 48.308C110.172 49.7991 111.934 50.9816 113.875 51.787C115.817 52.5924 117.898 53.0047 120 53V150Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.75 78C98.75 91.1168 88.1168 101.75 75 101.75C61.8832 101.75 51.25 91.1168 51.25 78C51.25 64.8832 61.8832 54.25 75 54.25C88.1168 54.25 98.75 64.8832 98.75 78Z",
    stroke: "#17428B",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_10111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 78C66 79.1819 66.2328 80.3522 66.6851 81.4442C67.1374 82.5361 67.8003 83.5282 68.636 84.364C69.4718 85.1997 70.4639 85.8626 71.5558 86.3149C72.6478 86.7672 73.8181 87 75 87C76.1819 87 77.3522 86.7672 78.4442 86.3149C79.5361 85.8626 80.5282 85.1997 81.364 84.364C82.1997 83.5282 82.8626 82.5361 83.3149 81.4442C83.7672 80.3522 84 79.1819 84 78C84 76.8181 83.7672 75.6478 83.3149 74.5558C82.8626 73.4639 82.1997 72.4718 81.364 71.636C80.5282 70.8003 79.5361 70.1374 78.4442 69.6851C77.3522 69.2328 76.1819 69 75 69C73.8181 69 72.6478 69.2328 71.5558 69.6851C70.4639 70.1374 69.4718 70.8003 68.636 71.636C67.8003 72.4718 67.1374 73.4639 66.6851 74.5558C66.2328 75.6478 66 76.8181 66 78Z",
    stroke: "#36C106",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 78L74 80L78 76",
    stroke: "#36C106",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
    fill: "#DFEAFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
    fill: "#DFEAFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_356_10111",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_10111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(63 66)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditcomp);
export default __webpack_public_path__ + "static/media/Auditcomp.5015bbd2495da88e4c8722e74fd51fcb.svg";
export { ForwardRef as ReactComponent };